export function isValidCPF(cpf) {
	const digits = cpf.replace(/\D/g, "");

	if (digits.length !== 11 || /^(\d)\1{10}$/.test(digits)) {
		return false;
	}

	const calculateCheckDigit = (base) => {
		let sum = 0;
		for (let i = 0; i < base.length; i++) {
			sum += Number(base[i]) * (base.length + 1 - i);
		}
		const remainder = sum % 11;
		return remainder < 2 ? 0 : 11 - remainder;
	};

	const firstCheckDigit = calculateCheckDigit(digits.slice(0, 9));
	const secondCheckDigit = calculateCheckDigit(digits.slice(0, 10));

	return firstCheckDigit === Number(digits[9]) && secondCheckDigit === Number(digits[10]);
}
